<template>
  <div class="checkingPage">
    <van-cell-group class="ggInput monthCheckBox clearfix ggpad">
      <p class="fl">
        <span>本月</span>
        ({{insurance}})
      </p>
      <div class="fr monthControl ggpad">
        <a href="javascript:void(0);" class="controlLeft changeColor">&lsaquo;</a>
        <a href="javascript:void(0);" :class="['controlRight']">&rsaquo;</a>
      </div>
    </van-cell-group>
    <div class="userMsg ggpad clearfix">
      <dl class="fl userInfo">
        <dt class="userImg">
          <img :src="baseUrl+'img/logo.png'" alt />
        </dt>
        <dd class="userName">小冬瓜</dd>
        <dd class="userDepartment">智能研究院-Java</dd>
      </dl>
      <dl class="fr userRl clearfix">
        <dt class="fl">
          <img :src="baseUrl+'img/checking/monthIcon.png'" alt />
        </dt>
        <dd class="fl">打卡日历</dd>
      </dl>
    </div>
    <div class="signBox">
      <van-cell-group>
        <van-cell title="出勤天数" :value="workerDay+' 天'" class="ggInput" />
      </van-cell-group>
      <van-cell-group>
        <van-cell title="签到次数" :value="signInNumber+' 次'" class="ggInput" />
      </van-cell-group>
      <van-cell-group>
        <van-cell title="签退次数" :value="signOutNumber+' 次'" class="ggInput" />
      </van-cell-group>
      <van-cell-group>
        <van-cell
          title="请假天数"
          :value="leaveOffice+' 天'"
          is-link
          :arrow-direction="baseLeaveOffice"
          @click="showLeaveOfficePicker"
          class="ggInput"
        />
      </van-cell-group>
      <div v-if="showLeaveOffice" class="leaveOfficeDetail">
        <ul>
          <li class="leaveOfficeList">
            <van-cell-group>
              <van-cell title="2019-12-05(星期三）" :value="1.5+' 天'" class="ggInput" />
            </van-cell-group>
          </li>
          <li class="leaveOfficeList">
            <van-cell-group>
              <van-cell title="2019-12-06(星期四）" :value="0.5+' 天'" class="ggInput" />
            </van-cell-group>
          </li>
        </ul>
      </div>
      <van-cell-group>
        <van-cell
          title="迟到"
          :value="beLate+' 次'"
          class="ggInput"
          is-link
          :arrow-direction="baseBeLate"
          @click="showBeLatePicker"
        />
      </van-cell-group>
      <div v-if="showBeLate" class="beLateDetail">
        <ul>
          <li class="beLateList ggpad ggInput clearfix">
            <p class="fl">
              2019-12-05(星期三）8:30
              <span>上班迟到15分钟</span>
            </p>
            <p class="fl">
              <span>|</span> 去处理
            </p>
          </li>
          <li class="beLateList ggpad ggInput clearfix">
            <p class="fl">
              2019-12-06(星期四）8:30
              <span>上班迟到3分钟</span>
            </p>
            <p class="fl">
              <span>|</span> 去处理
            </p>
          </li>
        </ul>
      </div>
      <van-cell-group>
        <van-cell
          title="早退"
          :value="leaveEarly+' 次'"
          class="ggInput"
          is-link
          :arrow-direction="baseLeaveEarly"
          @click="showLeaveEarlyPicker"
        />
      </van-cell-group>
      <div v-if="showLeaveEarly" class="leaveEarlyDetail ggDetail">
        <ul>
          <li class="beLateList ggpad ggInput ggDetailList clearfix">
            <p class="fl">2019-11-12(星期三）17:25</p>
            <p class="fl">
              <span>|</span> 去处理
            </p>
          </li>
          <li class="beLateList ggpad ggInput ggDetailList clearfix">
            <p class="fl">2019-12-15(星期四）17:15</p>
            <p class="fl">
              <span>|</span> 去处理
            </p>
          </li>
        </ul>
      </div>

      <van-cell-group>
        <van-cell
          title="缺卡"
          :value="lackOfCard+' 次'"
          class="ggInput"
          is-link
          :arrow-direction="baselackOfCard"
          @click="showLackOfCardPicker"
        />
      </van-cell-group>
      <div v-if="showLackOfCard" class="lackOfCardDetail ggDetail">
        <ul>
          <li class="lackOfCardList ggpad ggInput ggDetailList clearfix">
            <p class="fl">2019-11-12(星期三）17:25</p>
            <p class="fl">
              <span>|</span> 去处理
            </p>
          </li>
          <li class="beLateList ggpad ggInput ggDetailList clearfix">
            <p class="fl">2019-12-15(星期四）17:15</p>
            <p class="fl">
              <span>|</span> 去处理
            </p>
          </li>
        </ul>
      </div>
      <van-cell-group>
        <van-cell
          title="出差"
          :value="onBusiness+' 次'"
          class="ggInput"
          is-link
          :arrow-direction="baseOnBusiness"
          @click="showOnBusinessPicker"
        />
      </van-cell-group>
      <div v-if="showOnBusiness" class="beLateDetail onBusinessDetail">
        <ul>
          <li class="beLateList onBusinessList ggpad ggInput clearfix">
            <p class="fl">
              0.5天
              <span>2019-12-08(星期四）8:30</span>
            </p>
            <p></p>
          </li>
          <li class="beLateList onBusinessList ggpad ggInput clearfix">
            <p class="fl">
              1.5天
              <span>2019-12-11(星期四）8:30</span>
            </p>
            <p></p>
          </li>
        </ul>
      </div>
      <van-cell-group>
        <van-cell
          title="加班"
          :value="overTime+' 小时'"
          class="ggInput"
          is-link
          :arrow-direction="baseOverTime"
          @click="showOverTimePicker"
        />
      </van-cell-group>
      <div v-if="showOverTime" class="beLateDetail overTimeDetail">
        <ul>
          <li class="beLateList overTimeList ggpad ggInput clearfix">
            <p class="fl">
              8.00小时(12-08)
              <span>2019-12-06 8:30-2019-12-07 09:24</span>
            </p>
            <p class="fl">查看详情</p>
          </li>
          <li class="beLateList ggpad ggInput clearfix">
            <p class="fl">
              2.00小时(12-11)
              <span>2019-12-11 17:30-2019-12-11 20:40</span>
            </p>
            <p class="fl">查看详情</p>
          </li>
        </ul>
      </div>
      <van-cell-group>
        <van-cell
          title="补卡申请"
          :value="cardReplacemen+' 次'"
          class="ggInput"
          is-link
          :arrow-direction="baseCardReplacemen"
          @click="showCardReplacemenPicker"
        />
      </van-cell-group>
      <div v-if="showCardReplacemen" class="  cardReplacemenDetail">
        <ul>
          <li class="  cardReplacemenList ggpad ggInput clearfix">
            <p class="fl">2019-12-08(星期四）8:30</p>
             
          </li>
          <li class="  cardReplacemenList ggpad ggInput clearfix">
            <p class="fl">2019-12-11(星期四）8:30</p>
            
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "myCheckingIn",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      insurance: "2019年11月", //当前月份的
      workerDay: "23", //出勤天数
      signInNumber: "23", //签到次数
      signOutNumber: "23", //签退次数
      leaveOffice: "2.0", //请假天数
      baseLeaveOffice: "up", //请假天数箭头方向
      showLeaveOffice: false, //请假天数弹框默认隐藏
      beLate: "4", //迟到次数
      baseBeLate: "up", //迟到次数箭头方向
      showBeLate: false, //迟到次数弹框默认隐藏
      leaveEarly: "2", //早退次数
      baseLeaveEarly: "up", //早退次数箭头方向
      showLeaveEarly: false, //早退次数弹框默认隐藏
      lackOfCard: "2", //缺卡次数
      baselackOfCard: "up", //缺卡次数箭头方向
      showLackOfCard: false, //缺卡次数弹框默认隐藏
      onBusiness: "1", //出差次数
      baseOnBusiness: "up", //出差次数箭头方向
      showOnBusiness: false, //出差次数弹框默认隐藏
      overTime: "13", //加班时间
      baseOverTime: "up", //加班时间箭头方向
      showOverTime: false, //加班时间弹框默认隐藏
      cardReplacemen: "2", //补卡次数C
      baseCardReplacemen: "up", //加班时间箭头方向
      showCardReplacemen: false //加班时间弹框默认隐藏
    };
  },
  created() {
    document.title = "考勤汇总";
  },
  mounted() {},
  methods: {
    showLeaveOfficePicker() {
      //请假次数弹框
      let _this = this;
      _this.showLeaveOffice = !_this.showLeaveOffice;
      if (_this.baseLeaveOffice != "down") {
        _this.baseLeaveOffice = "down";
      } else {
        _this.baseLeaveOffice = "up";
      }
    },
    showBeLatePicker() {
      //迟到次数弹框
      let _this = this;
      _this.showBeLate = !_this.showBeLate;
      if (_this.baseBeLate != "down") {
        _this.baseBeLate = "down";
      } else {
        _this.baseBeLate = "up";
      }
    },
    showLeaveEarlyPicker() {
      //早退次数弹框
      let _this = this;
      _this.showLeaveEarly = !_this.showLeaveEarly;
      if (_this.baseLeaveEarly != "down") {
        _this.baseLeaveEarly = "down";
      } else {
        _this.baseLeaveEarly = "up";
      }
    },
    showLackOfCardPicker() {
      //缺卡次数弹框
      let _this = this;
      _this.showLackOfCard = !_this.showLackOfCard;
      if (_this.baselackOfCard != "down") {
        _this.baselackOfCard = "down";
      } else {
        _this.baselackOfCard = "up";
      }
    },
    showOnBusinessPicker() {
      //出差次数弹框
      let _this = this;
      _this.showOnBusiness = !_this.showOnBusiness;
      if (_this.baseOnBusiness != "down") {
        _this.baseOnBusiness = "down";
      } else {
        _this.baseOnBusiness = "up";
      }
    },
    showOverTimePicker() {
      //加班时间弹框
      let _this = this;
      _this.showOverTime = !_this.showOverTime;
      if (_this.baseOverTime != "down") {
        _this.baseOverTime = "down";
      } else {
        _this.baseOverTime = "up";
      }
    },
    showCardReplacemenPicker() {
      //补卡申请弹框
      let _this = this;
      _this.showCardReplacemen = !_this.showCardReplacemen;
      if (_this.baseCardReplacemen != "down") {
        _this.baseCardReplacemen = "down";
      } else {
        _this.baseCardReplacemen = "up";
      }
    }
  }
};
</script>
<style lang="less">
.checkingPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  font-family: "PingFangSC-Regular", "PingFang SC";
  .ggInput {
    height: 45px;
    border-bottom: 1px solid #e9eaec;
    .van-cell__value {
      span {
        color: #000;
      }
    }
    .van-cell__right-icon {
      color: #aaa;
      margin-left: 8px;
    }
  }
  .ggpad {
    padding: 0 12px;
  }

  .monthCheckBox {
    font-size: 14px;
    color: #000;
    line-height: 45px;
    margin-bottom: 12px;
    .monthControl {
      a {
        display: inline-block;
        font-size: 22px;
        color: #aaa;
        width: 30px;
        height: 45px;
        text-align: center;
      }
      a.changeColor {
        color: #3c78f9;
      }
    }
  }
  .userMsg {
    width: 100%;
    height: 58px;
    background-color: #fff;
    dl.userInfo {
      position: relative;
      width: 70%;
      height: 58px;
      dt {
        width: 38px;
        height: 38px;
        position: absolute;
        top: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      dd {
        display: inline-block;
        position: absolute;
        font-size: 14px;
        color: #000;
        line-height: 20px;
      }
      dd.userName {
        top: 10px;
        left: 52px;
      }
      dd.userDepartment {
        top: 30px;
        left: 52px;
        color: #aaa;
      }
    }
    dl.userRl {
      width: 30%;
      height: 100%;
      position: relative;
      dt {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 5px;
        position: absolute;
        top: 50%;
        margin-top: -8px;
        right: 50px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      dd {
        color: #3c78f9;
        font-size: 12px;
        line-height: 17px;
        position: absolute;
        top: 50%;
        margin-top: -6px;
        right: 0;
      }
    }
  }
  .signBox {
    margin-top: 5px;
    // background-color: #fff;
    .ggInput {
      .van-cell__title,
      .van-cell__value {
        span {
          font-size: 16px;
        }
      }
      .van-cell__value {
        span {
          color: #aaa;
        }
      }
    }
  }
  .leaveOfficeDetail {
    width: 100%;
    .leaveOfficeList {
      width: 100%;
      .van-cell-group {
        background-color: #f6f6f6;
        .van-cell {
          background-color: #f6f6f6;
        }
      }
    }
  }
  .beLateDetail {
    width: 100%;
    .beLateList {
      width: 100%;
      height: 45px;
      p {
        font-size: 16px;
        display: inline-block;
      }
      p:first-child {
        color: #000;
        width: 70%;
        position: relative;
        padding-top: 3px;
        span {
          color: #828282;
          font-size: 12px;
          position: absolute;
          left: 0;
          top: 25px;
        }
      }
      p:last-child {
        width: 30%;
        line-height: 45px;
        color: #3c78f9;
        text-align: right;
        span {
          font-size: 20px;
          display: inline-block;
          color: #e0e1e3;
          margin-right: 8px;
        }
      }
    }
  }
  .ggDetail {
    width: 100%;
    .ggDetailList {
      width: 100%;
      height: 45px;
      line-height: 45px;
      p {
        font-size: 16px;
      }
      p:first-child {
        color: #000;
        width: 70%;
        position: relative;
      }
      p:last-child {
        width: 30%;
        color: #3c78f9;
        text-align: right;
        span {
          font-size: 20px;
          display: inline-block;
          color: #e0e1e3;
          margin-right: 8px;
        }
      }
    }
  }
   .cardReplacemenDetail{
       p {
        font-size: 16px;
        line-height:45px;
         color: #000;
        width:100%;
      }
  }
}
</style>